export default "__VITE_ASSET__BQEWXfOO__"